//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'swipe_magic_nav',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};